module.exports = __webpack_public_path__ + "media/images/application/template/search-d0f486d25d760c8031dd4ce1458cc979.svg";